import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {LayoutHighlightedBackgroundOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/layout-highlighted-background-option';
import {LayoutHighlightedTextColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/layout-highlighted-text-color-option';
import {LayoutHighlightedBackgroundOpacityOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/layout-highlighted-background-opacity-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface ScheduleDateOptionsProps {
  onClickHighlightedBackgroundOption(): void;
  onClickHighlightedTextOption(): void;
}

export function ScheduleDateOptions({...props}: ScheduleDateOptionsProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const layoutStyle = useGetKeyFromTableItem('layoutStyle');

  if (!activeItem || (activeItem && !('layoutStyle' in activeItem))) {
    throw new Error('Active item does not exist! or layout style is not an attribute in active item');
  }

  if (!activeItem.isSchedule() || layoutStyle === undefined) {
    return null;
  }

  if (!activeItem.doesItemHaveDateOptions()) {
    return null;
  }

  return (
    <>
      <ContextualMenuHeadingOption id="schedule-date-styles-option" text={window.i18next.t('pmwjs_date_styles')} />
      <LayoutHighlightedBackgroundOption
        onClickColorFill={(): void => {
          props.onClickHighlightedBackgroundOption();
        }}
      />
      <LayoutHighlightedTextColorOption
        onClickColorFill={(): void => {
          props.onClickHighlightedTextOption();
        }}
      />
      <LayoutHighlightedBackgroundOpacityOption />
    </>
  );
}
